import { memo } from 'react';
import { ChildrenProps } from '@dfl/mui-react-common';
import { AuthOptions } from 'modules/authentication/components/AuthOptions';
import { alpha, Stack, SxProps } from '@mui/material';
import { FormCard } from '@dfl/mui-form-layout';
import themeConfig from 'settings/branding';

const AuthLayout = ({ children, className, sx, maxWidth }: ChildrenProps & { className?: string, sx?: SxProps, maxWidth?: number }) => {
  return (
    <Stack
      alignItems={'center'}
      className={className}
      justifyContent={'center'}
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(107deg, ${alpha(themeConfig.theme.primary.main, 0.5)} 0.45%, ${alpha(themeConfig.theme.primary.light, 0.1)} 99.55%)`,
        ...sx
      }}
    >
      <FormCard rounded sx={{ maxWidth: maxWidth || 1000, p: '0px !important', borderRadius: '30px' }}>
        <div>{children}</div>
      </FormCard>
      <AuthOptions />
    </Stack>
  );
};

export default memo(AuthLayout);
